import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'PARENTAL_PERMISSIONS';

export const {action: showAddPermission} = createAction(`${domain}/SHOW_ADD_PERMISSION`, (show: boolean) => ({show}));
